// Module
var code = "<div class=\"widget-content relative\" wt-droppable> <wt-loading-panel is-loading=\"vm.isLoading\" message=\"vm.loadingMessage\"></wt-loading-panel> <wt-multi-bullet-chart class=\"bullet-chart\" id=\"{{'businessKpi' + vm.item.guid}}\" kpi-list=\"vm.kpiVmList\" ratio=\"vm.ratio\"> </wt-multi-bullet-chart> </div>";
// Exports
module.exports = code;